/**
 * - Styles override to MUIDialog to match Vacasa owner onboarding design
 */
const muiDialog = {
    styleOverrides: {
        paper: () => ({
            borderRadius: "16px",
        })
    },
}

export default muiDialog
